import axios from 'axios';
import { DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH } from '@alfa-bank/site-dc-env-config';

import type { IDeliveriesSearchApiArgs, IDeliveriesSearchResponse } from '../models';

export const deliveriesSearchApi = ({
    appId,
    businessUid,
    ...addressData
}: IDeliveriesSearchApiArgs) => {
    return axios.post<IDeliveriesSearchResponse>(
        DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH({ appId }),
        addressData,
        {
            headers: {
                'Content-Type': 'application/json',
                BusinessUid: businessUid,
            },
        }
    );
};
